(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/collections/wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/collections/wagers.js');

'use strict';

svs.numbergames.mybets_common_wager.collections.Wagers = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.mybets_common_wager.models.Wager,
  modelId(attrs) {
    return attrs.wagerId;
  },
  initialize() {
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers initialize', this.models);
  },
  parse(models, options) {
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers parse', models, options);
    if (models && options.isActiveWagers) {
      models = svs.numbergames.mybets_core_wager.parsers.parseActiveWagers(models, options);
    }
    return models;
  },
  updateWager(wagerId) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers updateWager', wagerId);
    const success = model => {
      this.trigger('wager:fetched', model);
      if (options.success) {
        const context = options.context || this;
        options.success.call(context, model);
      }
    };
    const model = this.get(wagerId);
    if (!model) {
      this.create({
        wagerId
      }, {
        wait: true,
        idAttribute: 'wagerId',
        success,
        context: this
      });
    } else if (model.isNew()) {
      model.fetch({
        idAttribute: 'wagerId',
        success,
        context: this
      });
    } else {
      success(model);
    }
  }
});

 })(window);